<template>
	<div id="checkins-wrapper">
		<template v-if="all_checkins.length > 0">
			<div class="d-flex align-items-baseline mb-2 mx-25">
				<span class="text-uppercase text-gray-500 font-weight-bold mr-2">Check-ins</span>
				<div class="flex-grow-1">
					<span class="badge badge-primary text-lg" v-html="all_checkins.length" data-test="checkinCount" />
				</div>

				<span class="btn btn-sm btn-ghost-primary text-gray-500 cursor-pointer leading-none" data-test="addCheckinButton">
					<i
						v-if="can_create_checkin"
						@click="buildCheckinModal()"
						class="far fa-plus-circle text-xl"
						data-toggle="modal" data-target="#myModal" />
				</span>
			</div>

			<physician-checkins-item
				v-for="checkin in all_checkins.slice(0,numberToShow)"
				:key="checkin.id"
				:checkin="checkin"
				@checkin-deleted="deleteCheckin($event)">	
			</physician-checkins-item>

			<div class="text-center">
				<span 
					v-if="all_checkins.length > numberToShow"
					@click="showMore()"
					class="btn btn-ghost-primary text-gray-500 font-weight-bold" >Show More <i class="far fa-chevron-double-down text-sm"></i>
				</span>
			</div>			
		</template>

		<div v-else class="pt-3 text-center text-gray-700">
			<div class="text-2xl mb-2">No checkins found</div>
			<span
				v-if="can_create_checkin" 
				@click="buildCheckinModal()"
				class="btn btn-ghost-primary text-gray-700"
				data-toggle="modal" data-target="#myModal">
				Add one now!
				<i class="ml-1 far fa-plus-circle" />
			</span>
		</div>

		<checkin-view-modal :showing_checkin="showing_checkin" />
	</div>
</template>

<script>
	import PhysicianCheckinsItem from './PhysicianCheckinsItem'
	import CheckinViewModal from './CheckinViewModal'

	export default {

        components: {
            PhysicianCheckinsItem,
            CheckinViewModal,
        },

        props: ['morphable_id', 'morphable_type', 'display_name', 'photo_url', 'checkins', 'can_create_checkin'], 

        data () {
        	return {
        		numberToShow: 5,

	        	showing_checkin: { //declare arrays so vue won't complain
					checkin_type:[], 
					checkin_user:[],
					physician:[],
					service_lines: [],
				},

        		all_checkins: _.orderBy(this.checkins, 'created_at', 'desc'),

		        checkin_options: {
					checkinables: {
						morphable_id: this.morphable_id,
						morphable_type: this.morphable_type,
						display_name: this.display_name,
						photo_url: this.photo_url,
					},
		        },
        	};
        },

		mounted() {
		    //add newly created checkin to the checkins array
		    this.$root.$on('checkinadded', data => {
		    	data.forEach(newCheckin => {
		        	this.all_checkins.unshift(newCheckin);
		        });
		    });

		    this.$root.$on('checkin_updated', data => {
		    	this.all_checkins.splice(this.checkinIndex(data.id), 1); //remove
		    	this.all_checkins.push(data); //re-add
		    	this.$root.$emit('checkinshow', data.id);//and re-load modal

		    	this.all_checkins = _.orderBy(this.all_checkins, 'created_at', 'desc');
		    });

		    //find the checkin in the array and move it so it can be in props
		    this.$root.$on('checkinshow', id => { 
		    	var show_checkin = this.all_checkins.find(function (checkins) { 
					return checkins.id === id;
				});
		    	this.showing_checkin = show_checkin;

		    	//add physician display properties to the object
		    	this.showing_checkin.checkinable = this.checkin_options.checkinables;
		    });
		},

		methods: {
			buildCheckinModal() {
				this.$root.$emit('build_checkin_modal', { checkin_options: this.checkin_options });
			},

			showMore() {
				this.numberToShow = this.numberToShow + 5;
			},

            checkinIndex(checkinId) {
                return this.all_checkins.findIndex((element) => {
                    return element.id === checkinId;
                });
            },

            deleteCheckin($event) {
                Swal.fire({
                      title: 'Are you sure?',
                      text: 'You will not be able to recover this check-in.',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Delete check-in',
                      cancelButtonText: 'Keep check-in',
                      animation: false,
                    }).then((result) => {
                      if (result.value) {
                            axios.delete(`/api/checkins/${$event.id}`, $event)
                                .then(() => {
                                this.all_checkins.splice(this.checkinIndex($event.id), 1);
                            })
                        }
                    }
                );
            },              		    
	    	       	  	
		},

		// computed: {
  //           all_checkins_sorted() {
  //               return _.orderBy(this.all_checkins, 'created_at', 'desc');
  //           },
		// },      
	}
</script>